module.exports = __webpack_public_path__ + "receipt_4.c42e9269f613eb4af20ddd95678f6258.svg";